__turbopack_context__.v({
  "article": "BlogArticle-module__2-DL2q__article",
  "authorBack": "BlogArticle-module__2-DL2q__authorBack",
  "embedLink": "BlogArticle-module__2-DL2q__embedLink",
  "embedWrapper": "BlogArticle-module__2-DL2q__embedWrapper",
  "heroImage": "BlogArticle-module__2-DL2q__heroImage",
  "metaLeft": "BlogArticle-module__2-DL2q__metaLeft",
  "metaRow": "BlogArticle-module__2-DL2q__metaRow",
  "readTime": "BlogArticle-module__2-DL2q__readTime",
  "releaseDate": "BlogArticle-module__2-DL2q__releaseDate",
  "similar": "BlogArticle-module__2-DL2q__similar",
  "similarCard": "BlogArticle-module__2-DL2q__similarCard",
  "similarList": "BlogArticle-module__2-DL2q__similarList",
});
